/**
 * Define security questions list
 */
export default {
    global: {
        tou: '/main/{locale}/legal/tou',
        privacy: '/main/{locale}/legal/privacy',
    },
    one: {
        tou: '/main/{locale}/legal/tou',
        privacy: '/main/{locale}/legal/privacy',
    },
    th: {
        tou: '/main/{locale}/legal/tou',
        privacy: '/main/{locale}/legal/privacy',
    },
    tw: {
        tou: '/main/{locale}/legal/tou',
        privacy: '/main/{locale}/legal/privacy',
    },
    sea: {
        tou: '/main/{locale}/legal/tou',
        privacy: '/main/{locale}/legal/privacy',
    },
    japan: {
        tou: '/account/{locale}/global/terms-of-use',
        privacy: '/account/{locale}/global/privacy-policy',
    },
};
